import { React, BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './App.css';
import AppRoutes from './Routes/appRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { ToastContainer } from 'react-toastify';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import logo from "../src/EpicGame/Assets/images/pngwing.com.png"

function App() {

  const [user, setUser] = useState();

  useEffect(() => {
    const data = localStorage.getItem('user');
    if (data) {
      const userObj = JSON.parse(data);
      setUser(userObj);
    }
  }, []);

  useEffect(() => {
    if (window.Tawk_API) {
      if (typeof window.Tawk_API.setAttributes === 'function') {
        window.Tawk_API.setAttributes(
          {
            name: user?.FirstName,
            email: user?.Email,
          },
          (error) => {
            if (error) {
              console.error('Error setting Tawk.to attributes:', error);
            }
          }
        );
      } else if (window.Tawk_API.visitor) {
        // fallback if setAttributes not available yet
        window.Tawk_API.visitor = {
          name: user?.FirstName,
          email: user?.Email,
        };
      }
    }
  }, [user]);
  return (
    <>
      <AppRoutes />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <FloatingWhatsApp
        phoneNumber="+13322692184"
        accountName="Epic Support"
        allowClickAway
        notification
        notificationSound
        message="Hi there! 👋 How can we help you today?"  // ✅ Custom first message
        avatar={logo} // optional
      /> */}

    </>
  );
}

export default App;
